import { defineRecipe } from '@chakra-ui/react';

/*
 * v3 port notes: the built-in `container` recipe steps `px` per breakpoint
 * (`{ base: '4', md: '6', lg: '8' }`). v3 merges recipe and prop styles per
 * breakpoint (v2 replaced the whole value), so a call-site `p="0"`/`px="0"`
 * only cleared the base step and the recipe's 24px/32px padding came back
 * from 701px up. Restores v2's flat `px: '4'` so a call-site `px` replaces
 * it at every width.
 */

export const containerTheme = defineRecipe({
  base: {
    px: '4',
  },
});

export default containerTheme;
